export default __webpack_public_path__ + "static/ally-03692add7f71b0962ff3efd758cf985a.png";